import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastr: ToastrService) { }

  showInfo(message: string, title: string = null) {
    this.toastr.info(message, title)
  }

  showSuccess(message: string, title: string = null) {
    this.toastr.success(message, title)
  }

  showWarning(message: string, title: string = null) {
    this.toastr.warning(message, title)
  }

  showError(message: string, title: string = null) {
    this.toastr.error(message, title)
  }

}
